import React, { useState } from "react";
import { func, shape, string } from "prop-types";
import { Form } from "informed";
import Button from "../../Button";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./forgotPasswordForm.module.scss";
import UIkit from "uikit";
import { useIntl } from "react-intl";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { isEmailValid } from "@Src_main/utils/generalUtils";
import { SimpleField } from "@Components/FormFields/SimpleField";
var ForgotPasswordForm = props => {
  var classes = mergeClasses(defaultClasses, props.classes);
  var {
    initialValues,
    onSubmit
  } = props;
  var {
    isMobile
  } = useWindowSize();
  var {
    formatMessage
  } = useIntl();
  var [buttonEnable, setbuttonEnable] = useState(false);
  var [isEmailOk, setIsEmailOk] = useState(false);
  var handleChange = event => {
    var emailValid = event.values.email && isEmailValid(event.values.email);
    if (emailValid) {
      setIsEmailOk(true);
      setbuttonEnable(true);
    } else {
      setIsEmailOk(false);
      setbuttonEnable(false);
    }
  };
  var formStep1 = /*#__PURE__*/React.createElement(SimpleField, {
    id: "emailForgotPassword",
    name: "email",
    label: "input.email",
    type: "email",
    required: true,
    invalid: !isEmailOk
  });
  return /*#__PURE__*/React.createElement(Form, {
    className: "".concat(classes.form_container, " uk-flex uk-flex-column"),
    initialValues: initialValues,
    onSubmit: onSubmit,
    onChange: handleChange,
    "data-uk-height-viewport": "offset-top: true"
  }, formStep1, /*#__PURE__*/React.createElement("div", {
    className: classes.button_container_pwdforgot,
    onClick: () => {
      try {
        UIkit.offcanvas("#offcanvas-pwdforgot-dx").hide();
      } catch (error) {
        console.error(error);
      }
    }
  }, /*#__PURE__*/React.createElement(Button, {
    id: "forgotPass",
    disabled: !buttonEnable,
    color: "primary",
    fullScreen: true,
    type: "submit",
    extraClass: isMobile ? " uk-margin-small-bottom uk-margin-xlarge-bottom" : "uk-margin-small-top"
  }, /*#__PURE__*/React.createElement("span", null, formatMessage({
    id: "button.confirm"
  })))));
};
ForgotPasswordForm.propTypes = {
  classes: shape({
    form: string,
    buttonContainer: string
  }),
  initialValues: shape({
    email: string
  }),
  onCancel: func.isRequired,
  onSubmit: func.isRequired
};
ForgotPasswordForm.defaultProps = {
  initialValues: {}
};
export default ForgotPasswordForm;